// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mjVw","badges":"styles_badges__2mHDl"};